import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';
import { ICheckoutSession, IProductPrice, ISubscriptionSession } from '.';

interface ICreateSession {
  diagnosticId: string;
}

interface ICreatePremiumSession {
  userId: string;
  priceId: string;
  returnUrl: string;
}

interface IGetPremiumPrice {
  userId: string;
  country: string;
}

const StripeApiDataProvider = new APIDataProvider<ICheckoutSession>();
const ProductApiDataProvider = new APIDataProvider<IProductPrice>();
const PremiumProductApiDataProvider = new APIDataProvider<IProductPrice[]>();
const SubscriptionApiDataProvider = new APIDataProvider<ISubscriptionSession>();

export const createSession = createAsyncThunk(
  'stripe/createSession',
  async (data: ICreateSession) => {
    const response = await StripeApiDataProvider.create(
      `${ApiPaths.stripe}/createSession`,
      data
    );
    return response.data;
  }
);

export const getProductPrice = createAsyncThunk(
  'stripe/getProductPrice',
  async (diagnosticId: string) => {
    const response = await ProductApiDataProvider.getById(
      `${ApiPaths.stripe}/getProductPrice/${diagnosticId}`
    );
    return response.data;
  }
);

export const createPremiumSession = createAsyncThunk(
  'stripe/premium/createSession',
  async (data: ICreatePremiumSession) => {
    const response = await StripeApiDataProvider.create(
      `${ApiPaths.stripe}/premium/createSession`,
      data
    );
    return response.data;
  }
);

export const getPremiumProductPrice = createAsyncThunk(
  'stripe/premium/getProductPrice',
  async (data: IGetPremiumPrice) => {
    const response = await PremiumProductApiDataProvider.create(
      `${ApiPaths.stripe}/premium/getProductPrice`,
      data
    );
    return response.data;
  }
);

export const getSubscriptionSessionById = createAsyncThunk(
  'stripe/premium/getById',
  async (id: string) => {
    const response = await SubscriptionApiDataProvider.getById(
      `${ApiPaths.stripe}/premium/${id}`
    );
    return response.data;
  }
);

export const getCustomerPortal = createAsyncThunk(
  'stripe/customerPortal',
  async (userId: string) => {
    const response = await SubscriptionApiDataProvider.getById(
      `${ApiPaths.stripe}/customerPortal/${userId}`
    );
    return response.data;
  }
);
